function updatecart(url) {
    fetch(url).then(function (response) {
        // The API call was successful!
        return response.text();
    }).then(function (html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        document.querySelector(".header__icon--cart").innerHTML = doc.querySelector(".header__icon--cart").innerHTML;
        document.querySelector(".new-cart-drawer").innerHTML = doc.querySelector(".new-cart-drawer").innerHTML;

        $("cart-drawer")[0].open();
        observeCartChanges()
    }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
    });
}

function observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
            const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
            const isCartChangeRequest = /\/cart\//.test(entry.name);
            if (isValidRequestType && isCartChangeRequest) {
                setTimeout(() => {
                    if (!document.querySelectorAll("cart-drawer.active").length) {
                        $("cart-drawer")[0].open();
                    }
                }, 1000);
            }
        });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
}



document.addEventListener("DOMContentLoaded", function () {
    let header = document.querySelector("sticky-header");
    let stickyClass = "sticky-header";

    // Passive, and only touching the class list when the answer actually
    // changed: with smooth scrolling this runs every frame of every gesture,
    // and the old version re-asserted the class on all of them.
    let isStuck = null;

    // `<sticky-header>` only exists while the sticky setting is on, and without
    // this the listener threw on every scroll event of every frame on the
    // templates where it isn't.
    if (header) {
        window.addEventListener(
            "scroll",
            function () {
                const shouldStick = window.scrollY > 40;
                if (shouldStick === isStuck) return;
                isStuck = shouldStick;
                header.classList.toggle(stickyClass, shouldStick);
            },
            { passive: true }
        );
    }

    document.querySelectorAll("#add-to-cart_extra").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            var checkboxes = document.querySelectorAll(".image_check_box input:checked");
            var items = [];
            checkboxes.forEach(function (checkbox) {
                var val = checkbox.value;

                items.push({
                    id: parseInt(val),
                    quantity: 1
                })
            });


            jQuery.post('/cart/add.js', {
                items: items
            }).done(function (data) {
                if (window.cartType != 'drawer') {
                    window.location.href = '/cart';
                } else {
                    updatecart('/')
                }

            })
        });
    });

    document.querySelectorAll(".button_add_cart").forEach(function (add) {
        add.addEventListener("click", function (e) {
            e.preventDefault();
            var id = this.parentElement.querySelector("input").value;
            var items = [];
            items.push({
                id: parseInt(id),
                quantity: 1
            })

            jQuery.post('/cart/add.js', {
                items: items
            }).done(function (data) {
                if (window.cartType != 'drawer') {
                    window.location.href = '/cart';
                } else {
                    updatecart('/')
                }

            })
        })
    })


});












